import type { CopyShape } from "../../intl";

import type { PLAN_INQUIRY_COPY_PT_BR } from "../plan-inquiry.copy";

export const PLAN_INQUIRY_COPY_ES_ES: CopyShape<typeof PLAN_INQUIRY_COPY_PT_BR> = {
  sentTitle: "¡Listo!",
  description: "Cuéntanos el tamaño de tu operación y te preparamos la propuesta adecuada.",
  sentDescription: "Hemos recibido tu solicitud.",
  closeLabel: "Cerrar",
  nameLabel: "Tu nombre",
  emailLabel: "Tu correo electrónico",
  whatsappLabel: "WhatsApp con prefijo",
  creatorsCountLabel: "Cuántos creators (opcional)",
  messageLabel: "¿Quieres contarnos algo más? (opcional)",
  sentMessage:
    "Te escribimos por WhatsApp o al correo que nos has dejado para concretar los siguientes pasos.",
  errorMessage: "No hemos podido enviar ahora. Vuelve a intentarlo en unos instantes.",
  submitLabel: "Enviar solicitud",
  submittingLabel: "Enviando...",
  requestProposal: {
    description: "Cuéntanos el tamaño de tu operación y te preparamos la propuesta adecuada.",
    needsPhoneDescription:
      "Solo falta confirmar tu teléfono: es por ahí por donde te avisamos cuando la propuesta esté lista.",
    sentMessage:
      "Te escribimos por WhatsApp o al correo de tu cuenta para concretar los siguientes pasos.",
    nameLabel: "Nombre",
    emailLabel: "Correo electrónico",
    whatsappLabel: "WhatsApp",
    empty: "—",
    creatorsCountLabel: "Cuántos creators",
    optional: "(opcional)",
    creatorsSuffix: "creators",
    submit: "Pedir propuesta",
  },
  phoneVerification: {
    phoneLabel: "WhatsApp",
    phoneHint: "Es por ahí por donde te avisamos cuando la propuesta esté lista.",
    codeLabel: "Código recibido por SMS",
    confirm: "Confirmar y enviar solicitud",
    resend: "Reenviar código",
    sendCode: "Enviar código por SMS",
  },
};
